import { mapGetters } from 'vuex';
import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';

import { DEFAULT_MODAL_HEIGHT, resizeModalDialogIniFrame } from '@/utils/modal-utils.js';

import { getCollapseSimplifyViewObserver } from '@/utils/collapse-simplify-view-observer';

export default {
  computed: {
    ...mapGetters(['boughtPlans', 'getSelectedPlans', 'isCollapseSimplifyView']),
    mxIsSimplifyForProEdit() {
      const { simplify, edit, modal } = this.$context.is;

      const selectedMeetingPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);

      const isOnlyPro = this.getSelectedPlans.length === 1 && selectedMeetingPlan?.category === BASE_PLAN_SUB_TYPES.PRO;

      return modal & simplify && edit && isOnlyPro;
    },
    mxClassForSimplify() {
      return this.mxIsSimplifyForProEdit ? ['opc-simplify'] : [];
    },
    mxClassForSimplifyCompound() {
      return this.mxIsSimplifyCompoundView ? ['opc-simplify'] : [];
    },
    mxShowExtraElementForCollapseSimplifyView() {
      return !this.mxIsSimplifyForProEdit || this.mxIsSimplifyCompoundView;
    },
    mxShowOperationButtonForSimplifyView() {
      return this.mxIsSimplifyForProEdit && this.isCollapseSimplifyView;
    },
    mxIsSimplifyCompoundView() {
      return this.mxIsSimplifyForProEdit && !this.isCollapseSimplifyView;
    },
  },
  methods: {
    mxCheckCollapseSimplifyView({ billingCycle, selectedNumber }) {
      if (!this.mxIsSimplifyForProEdit || !this.isCollapseSimplifyView) return;
      const boughtMeetingPlan = this.boughtPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
      const bounghtBillingCycle = boughtMeetingPlan?.billing_cycle;
      const boungtLicenses = boughtMeetingPlan?.cartInfo?.selected_number;
      if (billingCycle !== bounghtBillingCycle || selectedNumber !== boungtLicenses) {
        if (this.isCollapseSimplifyView) {
          this.$store.commit('updateIsCollapseSimplifyView', false);
          const collapseSimplifyViewObserver = getCollapseSimplifyViewObserver();
          collapseSimplifyViewObserver?.disconnect?.();
          // * resize window
          resizeModalDialogIniFrame({
            height: DEFAULT_MODAL_HEIGHT,
          });
        }
      }
    },
    mxAnchorIntersectionObserver(ancherEle, callback = () => {}) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              callback(observer, entry.target);
            }
          });
        },
        {
          threshold: 1,
        },
      );
      if (ancherEle) {
        observer.observe(ancherEle);
      }
    },
  },
};
